import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export const sendFollowupRequest = async (name: string, email: string, customerId: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/neatt/followup`, {
            name,
            email,
            customerId
        });

        return result
    } catch (error) {
        throw error;
    }
};

export const sendInviteClient = async (name: string, email: string, referrerId: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/neatt/invite-client`, {
            name,
            email,
            referrerId,
        });

        return result
    } catch (error) {
        throw error;
    }
};

export const sendInviteMember = async (name: string, email: string, referrerId: string, referrerName: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/subscribers/invite-member`, {
            name,
            email,
            referrerId,
            referrerName
        });

        return result
    } catch (error) {
        throw error;
    }
};

export const sendProfileComplete = async (name: string, email: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/neatt/profile-complete`, {
            name,
            email,
        });

        return result
    } catch (error) {
        throw error;
    }
};

export const sendQuestion = async (firstName: string, lastName: string, phone: string, email: string, message: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/question`, {
            firstName,
            lastName,
            phone,
            email,
            message
        });

        return result
    } catch (error) {
        throw error;
    }
};

export const sendQuizRegistration = async (name: string, email: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/quiz-101-register`, { name, email })

        return result
    } catch (error) {
        throw error;
    } 
}

export const sendStudentStartedQuiz = async (name: string, email: string, quizName: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/student-start`, { name, email, quizName })

        return result
    } catch (error) {
        throw error;
    } 
}

export const sendStudentSubmittedQuiz = async (name: string, email: string, quizName: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/sendgrid/student-end`, { name, email, quizName })

        return result
    } catch (error) {
        throw error;
    } 
}